import React from 'react'
import { EduButton, FlexContainer, SearchInputStyled } from '@edulastic/common'
import { Tooltip } from 'antd'
import PropTypes from 'prop-types'

const AddUsersSection = ({
  setShowAddUsersModal,
  handleTableSearch,
  searchValue,
  saveButtonState,
}) => {
  const openModal = () => setShowAddUsersModal(true)
  const AddUserButton = (
    <EduButton
      isGhost
      height="34px"
      width="140px"
      mr="10px"
      onClick={openModal}
      data-cy="openAddUsersModalBtn"
      disabled={saveButtonState}
    >
      ADD USER(S)
    </EduButton>
  )
  return (
    <FlexContainer justifyContent="flex-end" padding="10px 0px">
      {saveButtonState ? (
        <Tooltip
          placement="bottom"
          title="Save your current changes before proceeding."
          trigger="hover"
        >
          <span>{AddUserButton}</span>
        </Tooltip>
      ) : (
        AddUserButton
      )}
      <SearchInputStyled
        placeholder="Search..."
        height="34px"
        width="310px"
        data-cy="searchUsersInputField"
        value={searchValue}
        onChange={handleTableSearch}
      />
    </FlexContainer>
  )
}

AddUsersSection.propTypes = {
  setShowAddUsersModal: PropTypes.func,
}
AddUsersSection.defaultProps = {
  setShowAddUsersModal: () => {},
}

export default AddUsersSection
